import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SequenceVersionDetail from './SequenceVersionDetail';
import {
  getUserProfileWidget,
  getCurrentTimezone,
  getProfile,
  getModelCategoryFlowSequences,
  getSequenceVersion,
  getUserOrgModelCategoryType
} from '../../selectors/index';

import { saveSequenceVersionThunk, describeSequenceVersionThunk, setSequenceVersionChangeThunk } from '../../actions/sequenceVersion';

const mapStateToProps = state => {
  return {
    userProfileWidgets: getUserProfileWidget(state),
    currentTimezone: getCurrentTimezone(state),
    profile: getProfile(state),
    flowSequences: getModelCategoryFlowSequences(state),
    sequenceVersionManager: getSequenceVersion(state),
    userModelCategories: getUserOrgModelCategoryType(state)

  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      saveSequenceVersion: (sequenceVersion, widgetCode, filesTobeUploaded=[]) => saveSequenceVersionThunk(sequenceVersion, widgetCode, filesTobeUploaded),
      describeSequenceVersion: (modelCategoryId, sequenceVersionId, widgetCode) => describeSequenceVersionThunk(modelCategoryId, sequenceVersionId, widgetCode),
      changeSequenceVersion: sequenceVersion => setSequenceVersionChangeThunk(sequenceVersion)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SequenceVersionDetail);
